<ng-content></ng-content>
<div id="spacing-placeholder"></div>